module.exports = __webpack_public_path__ + "static/media/authorized-access-only.5d0975e4.svg";